import { approve } from "./components/approve"; //审批页面
import { dept } from "./components/dept"; //部门管理
import { login } from "./components/login"; //登陆页面
import { CapitalInfo } from "./components/Capital-Info"; //客资界面

import { riskidentification } from "./components/risk-identification"; //风险管理
import { ControlRecords } from "./components/safe-Control-Records-risk"; //风险管控记录

import { securityConfig } from "./components/security-Config"; //安全检查
import { dangers } from "./components/dangers-Mission"; //隐患检查
import { tenants } from "./components/tenants"; //租户
import { laws } from "./components/laws"; //法律法规
import { mailbox } from "./components/Mailbox"; //信息中心
import { System } from "./components/safe-Corporate-System"; //公司制度

import { training } from "./components/Safety_training"; //安全培训
import { programmes } from "./components/safe-Training-programmes"; //培训计划
import { statistics } from "./components/safe-Training-Statistics"; //培训统计

import { official } from "./components/Official"; //公文管理
import { promise } from "./components/safe-Promise-document"; //承诺书管理

import { eme } from "./components/safe-Emergency-Supplies"; //应急物资
import { tem } from "./components/safe-Emergency-tem";//应急小组
import { process } from "./components/safe-Emergency-Process";//应急流程
import { exercise } from "./components/safe-Emergency-Exercise";//应急演练(单人)
import { people } from "./components/safe-Emergency-Exercise-people";//应急演练(多人)



import { home } from "./components/home"; //主页
import { homeView } from "./components/homeView"; //大屏监控页

import { venueSetting } from "./components/venueSetting"; //进出场管理

import { log } from "./components/log"; //日志管理
import { Agent } from "./components/Agent"; //代办管理
import { Onduty } from "./components/safe-employee-onduty"; //值班管理
import { Clock } from "./components/safe-employee-clock"; //人员打卡

import { ticketPlay } from "./components/check-Construction-play"; //生产计划列表
import { ticket } from "./components/check-confirm-ticket"; //安全确认票
import { TicketRecords } from "./components/check-confirm-ticket-Records"; //安全确认票历史


import { ReportSetting } from "./components/safe-report-setting"; //报告信息设置

export const mixin = {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("user")) ?? "", //本地存储对象
      Height: document.documentElement.clientHeight - 260 + "px", //用来给table设默认高度
    };
  },
  methods: {
    ...login.methods, //登陆的接口
    ...approve.methods, //审批的接口
    ...dept.methods, //部门的接口
    ...CapitalInfo.methods, //客资的接口
    ...riskidentification.methods, //风险管理
    ...ControlRecords.methods, //风险管控记录
    ...securityConfig.methods, //安全检查
    ...dangers.methods, //隐患检查
    ...tenants.methods, //租户
    ...laws.methods, //法律法规
    ...mailbox.methods, //信息中心
    ...System.methods, //公司制度
    ...training.methods, //安全培训
    ...programmes.methods, //培训计划
    ...statistics.methods, //培训统计

    ...official.methods, //公文管理
    ...promise.methods, //承诺书管理
    ...eme.methods, //应急物资
    ...tem.methods,//应急小组
    ...process.methods,//应急流程
    ...exercise.methods,//应急演练(单人)
    ...people.methods,//应急演练(多人)

    ...home.methods, //主页
    ...homeView.methods, //大屏监控
    ...venueSetting.methods, //进出场管理
    ...log.methods, //日志管理
    ...Agent.methods, //代办管理
    ...Onduty.methods, //值班管理
    ...Clock.methods, //人员打卡

    ...ticketPlay.methods, //生产计划列表
    ...ticket.methods, //安全确认票
    ...TicketRecords.methods, //安全确认票历史
    ...ReportSetting.methods, //报告信息设置

    //TODO: 查询租户角色
    async tenantRoles() {
      //参数是指定角色

      let res = await this.$http.get("/tenant/role/all/list");
      return res.data || [];
    },
    //查询当前用户权限及菜单列表
    async roleList(roleid) {
      //参数是指定角色
      var arr = [];

      if (roleid) {
        //如果是指定用户
        let res = await this.$http.get(`/tenant/permission/tree/list/${roleid}`);

        arr = res;
      } else {
        let res = await this.$http.get(`/tenant/permission/tree/list/${this.userInfo?.roleId}`,);
        arr = res;
      }
      if(arr.length > 0){
          //TODO: 排序
         function sortData(a, b) {
           return a.orderNum - b.orderNum
        }
        arr.sort(sortData);

        arr.forEach(item=>{
            if(item.children.length > 0){
              item.children.sort(sortData);
            }
        })
      }


      return arr || [];
    },
    //获取当前登录用户企业套餐中的权限
    async getTanentPackgesRoles(){
      let res = await this.$http.get("/tenant/permission/tree/init/list");
      if(res.length > 0){
        //TODO: 排序
       function sortData(a, b) {
         return a.orderNum - b.orderNum
      }
      res.sort(sortData);

      res.forEach(item=>{
          if(item.children.length > 0){
            item.children.sort(sortData);
          }
      })
    }
      return res || [];
    },
    //获取全部权限
    async roleListall() {
      //参数是指定角色

      let res = await this.$http.get("/roles/getrolesAllInfoPro");

      return res.data || [];
    },
    //数组对比差异方法
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    //TODO: 根据角色修改权限（数组传入）
    async updateRole(row) {
      let res = await this.$http.put("/tenant/role/update/permission",row,{
        "Content-Type":"application/json"
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
      return res || [];
    },
    //新增角色权限
    async addRole(roleid, pid) {
      try {
        let res = await this.$http.post("/roles/addrolePermission", {
          tenantId:this.userInfo.tenantId,
          pid: pid,
          roleid: roleid,
        });
      } catch (err) {
      }
    },
    //删除角色权限
    async delRole(roleid,pid) {
      try {
        let res = await this.$http.delete("/roles/delrolePermissionRoleid", {
          tenantId:this.userInfo.tenantId,
          pid: pid,
          roleid:roleid,
        });
      } catch (err) {
      }
    },
    //查询角色
    async getRoleList(obj) {
      let {pageNum,pageSize,roleName} = obj
      let res = await this.$http.get("/tenant/role/list",{
        roleName:roleName??null,
        pageNum:pageNum??null,
        pageSize:pageSize??null
      });
      return res;
    },
    //TODO:查询角色（分页）
    async getRoleListPages(params) {
      let {pageNum,pageSize,name} = params

      let res = await this.$http.get("/tenant/role/list",{
        name:name??null,
        pageNum:pageNum??null,
        pageSize:pageSize??null
      });
      return res;
    },
    //查询所有员工
    async getEmployee(params) {
      let {deptId,teamId,pageNum,pageSize,name} = params
      let res = await this.$http.get("/tenant/user/tenant/list",{
        deptId:deptId??null,
        //teamId:teamId??null,
        name:name??null,
        pageNum:pageNum??null,
        pageSize:pageSize??null
      });
      return res;
    },
    //查询所有账号角色
    async getEmployeeRoles(params) {
      let {pageNum,pageSize,name} = params
      let res = await this.$http.get("/tenant/user/role/list",{
        name:name??null,
        pageNum,
        pageSize
      });
      return res;
    },
    //根据employeeid查询员工
    async getEmployeeId(employeeid) {
      if (!employeeid) return false;
      let { data: res } = await this.$http.get(
        "/employee/getEmployeeid",
        {
          employeeid: employeeid,
        }
      );
      return res;
    },
    //新增角色
    async addRoleName(obj) {
      let res = await this.$http.post("/tenant/role", {
        roleName: obj.roleName,
      });
      if (res.code == 200) {
        this.$message({ message: "新增成功", type: "success" });
      } else {
        this.$message.error("新增失败");
        return;
      }
    },
    //修改角色
    async upRoleName(obj) {
      let res = await this.$http.put("/tenant/role", obj);
      if (res.code == 200) {
        this.$message({ message: "修改成功", type: "success" });
      } else {
        this.$message.error("修改失败");
        return;
      }
    },
    //删除角色
    async deRoleName(obj) {
      let res = await this.$http.delete(`/tenant/role/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //根据名称查询角色
    async searchRolename(roleName) {
      let res = await this.$http.get("/tenant/role/list", {
        roleName: roleName,
      });
      return res;
    },
    //根据员工employeeid查询权限
    async getemRole(val) {
      //根据employeeid查询权限
      let res = await this.$http.get("/roles/getroleEmployee", {
        employeeid: val,
      });
      return res.data || [];
    },
    //查询头像
    async getUserPic(val) {
      //根据employeeid查询权限
      let {
        data: { data: s2 },
      } = await this.$http.get(
        "/api/custom_capital_employee_photo/getByemployeeid",
        {
          employeeid: val,
        }
      );
      if (s2.list.length <= 0) return "";
      return s2.list[0];
    },
    //修改账号角色
    async upemployeeRole(row, type) {

      let res = await this.$http.put("/tenant/user/role", row);
      return res.code == 200 ? true : false;
    },

    //获取词典内容
    async getdicontent(val, state) {
      if (state == 0) {
        let {
          data: { data: ret },
        } = await this.$http.get(
          "/dictionary_content/getAllActiveBydictionary_name",
          {
            dictionary_name: val,
          }
        );

        return ret.list;
      } else {
        let {
          data: { data: ret },
        } = await this.$http.get(
          "/dictionary_content/getAllBydictionary_name",
          {
            dictionary_name: val,
          }
        );

        return ret.list;
      }
    },
    //获取门店
    async getdeptisIsshop() {
      let s1 = await this.getDeptall();
      return s1.filter((item) => item.isshop == 0);
    },
  },
};
